import type { MouseEvent } from 'react';
import { Link } from 'react-router';
import { useAtomValue, useSetAtom } from 'jotai';
import { userAtom, userProfileModalOpenAtom, userLoginModalOpenAtom } from '../atoms/userAtom';
import Avatar from './Avatar';

const UserMenu = () => {
  const user = useAtomValue(userAtom);
  const setUserProfileModalOpen = useSetAtom(userProfileModalOpenAtom);
  const setUserLoginModalOpen = useSetAtom(userLoginModalOpenAtom);

  const handleToggleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (!user) {
      setUserLoginModalOpen(true);
      return;
    }
    setUserProfileModalOpen(true);
  };

  return (<div className="user-menu navbar">
    <Link to="#" onClick={handleToggleClick}><Avatar src={user?.avatar} /></Link>
  </div>
  );
};

export default UserMenu;
